/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Submitticketsize_Modal_Mininputmustnotexceedmax8Inputs */

const en_coinvestments_submitticketsize_modal_mininputmustnotexceedmax8 = /** @type {(inputs: Coinvestments_Submitticketsize_Modal_Mininputmustnotexceedmax8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum must not exceed Maximum`)
};

/**
* | output |
* | --- |
* | "Minimum must not exceed Maximum" |
*
* @param {Coinvestments_Submitticketsize_Modal_Mininputmustnotexceedmax8Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_submitticketsize_modal_mininputmustnotexceedmax8 = /** @type {((inputs?: Coinvestments_Submitticketsize_Modal_Mininputmustnotexceedmax8Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Submitticketsize_Modal_Mininputmustnotexceedmax8Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_submitticketsize_modal_mininputmustnotexceedmax8(inputs)
});
export { coinvestments_submitticketsize_modal_mininputmustnotexceedmax8 as "coInvestments_submitTicketSize_modal_minInputMustNotExceedMax" }